<template>
  <v-container
    fluid
    dark
    class="mt-10 mb-12"
    :style="'overflow-y: scroll; max-height: 100%;'"
  >
    <v-card dark>
      <v-container fluid>
        <v-row v-if="$store.state.shippingInfo.method == 'pp'">
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h6" :style="'color: cyan;'"
              >Dane do wysyłki &nbsp;<v-icon
                :style="'transform: translateY(-3px)'"
                >fas fa-shipping-fast</v-icon
              ></span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span
              >{{ this.$store.state.shippingInfo.firstName }}
              {{ this.$store.state.shippingInfo.lastName }}</span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span
              >{{ this.$store.state.shippingInfo.street }} m.{{
                this.$store.state.shippingInfo.aptNumber
              }}</span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span
              >{{ this.$store.state.shippingInfo.zip }},
              {{ this.$store.state.shippingInfo.city }}</span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-1 pb-0">
            <span>Metoda wysyłki: Przesyłka nierejestrowana Poczta Polska</span>
          </v-col>
        </v-row>
        <v-row v-if="$store.state.shippingInfo.method == 'courier'">
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h6" :style="'color: cyan;'"
              >Dane do wysyłki &nbsp;<v-icon
                :style="'transform: translateY(-3px)'"
                >fas fa-shipping-fast</v-icon
              ></span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span
              >{{ this.$store.state.shippingInfo.firstName }}
              {{ this.$store.state.shippingInfo.lastName }}</span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span
              >{{ this.$store.state.shippingInfo.street }} m.{{
                this.$store.state.shippingInfo.aptNumber
              }}</span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span
              >{{ this.$store.state.shippingInfo.zip }},
              {{ this.$store.state.shippingInfo.city }}
              {{ this.$store.state.shippingInfo.country }}</span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-1 pb-0">
            <span>Metoda wysyłki: Kurier</span>
          </v-col>
        </v-row>
        <v-row v-if="$store.state.shippingInfo.method == 'ip'">
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h6 text-center" :style="'color: cyan;'"
              >Dane do wysyłki &nbsp;<v-icon
                :style="'transform: translateY(-3px)'"
                >fas fa-shipping-fast</v-icon
              ></span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0 text-center">
            <span class="text-center"
              >Paczkomat:
              <span :style="'color: cyan;'">{{
                this.$store.state.shippingInfo.boxId
              }}</span
              ><br />
              {{ this.$store.state.shippingInfo.boxText }}</span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span class="text-center"
              >Email:
              <span :style="'color: cyan;'">{{
                this.$store.state.shippingInfo.email
              }}</span></span
            >
          </v-col>

          <v-col cols="12" class="d-flex justify-center pt-1 pb-0">
            <span class="text-center">Metoda wysyłki: Paczkomat InPost</span>
          </v-col>
        </v-row>
        <v-divider class="mt-4 mb-4"></v-divider>
        <v-row>
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h6 text-center" :style="'color: cyan;'"
              >Zamówienie &nbsp;<v-icon :style="'transform: translateY(-3px)'"
                >fas fa-shopping-basket</v-icon
              ></span
            >
          </v-col>
          <v-col
            cols="12"
            class="d-flex justify-center pt-0 pb-0"
            v-for="item in $store.state.cart"
            :key="item.id"
          >
            <span class="text-center">{{ item.label }}</span>
          </v-col>
        </v-row>

        <v-divider class="mt-4 mb-4"></v-divider>
        <v-row>
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h6 text-center" :style="'color: cyan;'"
              >Płatność &nbsp;
              <v-icon :style="'transform: translateY(-3px)'"
                >fas fa-money-check-alt
              </v-icon>
            </span>
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span class="text-center"
              >Koszt zamówienia:
              <span :style="'color: green;'"
                >{{ $store.getters.cartTotal }}{{ $store.state.currency }}</span
              ></span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span class="text-center"
              >Koszt wysyłki: {{ $store.getters.shippingCost }}{{ $store.state.currency }}</span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span class="text-center"
              >SUMA:
              <span :style="'color: green;'"
                >{{
                  $store.getters.cartTotal + $store.getters.shippingCost
                }}{{ $store.state.currency }}</span
              ></span
            >
          </v-col>
          <v-col
            cols="12"
            class="d-flex justify-center pt-0 pb-0"
            v-if="$store.state.globalDiscount > 0"
          >
            <span :style="'color: cyan;'" class="text-center"
              >SUMA po zniżce (-{{ $store.state.globalDiscount }}%):
              <span :style="'color: green;'"
                >{{
                  parseInt(
                    ($store.getters.cartTotal + $store.getters.shippingCost) *
                      ((100 - $store.state.globalDiscount) / 100)
                  )
                }}{{ $store.state.currency }}</span
              ></span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span class="text-center">Metoda płatności: {{$store.getters.paymentMethodLabel}}</span>
          </v-col>
          <!-- <v-col
            cols="12"
            class="d-flex justify-center pt-0 pb-0 text-center"
            v-if="
              parseInt(
                ($store.getters.cartTotal + $store.getters.shippingCost) *
                  ((100 - $store.state.globalDiscount) / 100)
              ) > 100 &&
              parseInt(
                ($store.getters.cartTotal + $store.getters.shippingCost) *
                  ((100 - $store.state.globalDiscount) / 100)
              ) <= 4000
            "
          >
            <span :style="'color: #f34df9; font-size: 1.3rem;'"
              >Inne metody: <v-icon>fab fa-cc-visa</v-icon>&nbsp;<v-icon
                >fab fa-cc-mastercard</v-icon
              ></span
            >
          </v-col> -->
        </v-row>
        <v-divider class="mt-4 mb-4"></v-divider>
        <v-row>
          <v-col cols="12">
            <v-textarea
              name="input-7-1"
              v-model="additionalInfo"
              counter="200"
              filled
              label="Dodatkowe informacje do zamówienia"
              auto-grow
              placeholder="Tu możesz podać dodatkowe informacje do zamówienia dla nas"
              value=""
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              class="mt-2"
              dark
              block
              @click="placeOrder()"
              :loading="orderLoading"
              ><v-icon :style="'color: green;'">fas fa-check-circle</v-icon
              >&nbsp;Złóż zamówienie</v-btn
            >
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12">
            <v-alert
              border="top"
              colored-border
              light
              type="info"
              elevation="2"
            >
              Jeżeli masz pytania odnośnie realizacji zamówienia, wszystkie
              odpowiedzi znajdziesz w zakładce
              <a href="/faq" target="_blank">FAQ</a>. Po kliknięciu przycisku
              "złóż zamówienie", szczegóły zamówienia zostaną zaszyfrowane w
              naszym serwisie. Po realizacji zamówienia dane zostaną
              niezwłocznie usunięte. Zostaniesz przeniesiony na stronę płatności
              gdzie zostanie wyświetlony twój
              <span class="font-weight-bold" :style="'color: red;'"
                >numer zamówienia. Zapisz bezpiecznie ten numer!</span
              >
              Posłuży ci on do sprawdzenia statusu zamówienia lub kontaktu z
              nami. Na stronie płatności zostanie również wygenerowany adres
              Bitcoin na który należy opłacić zamówienie. Instrukcję jak
              bezpiecznie kupić Bitcoina znajdziesz klikając
              <a href="/bitcoin" target="_blank">tutaj</a>. <br />Dziękujęmy za
              zaufanie i życzymy wysokich lotów :D <br />
              Magic Garden
            </v-alert>
          </v-col>
        </v-row> -->
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "OrderOverviewView",
  data: () => ({
    orderLoading: false,
    additionalInfo: "",
  }),
  created: function () {
    if (!this.$store.getters.shippingInfoComplete) {
      this.$router.push("/koszyk");
    }
  },
  methods: {
    goToCart: function () {
      this.$router.push("/koszyk");
    },
    goToProducts: function () {
      this.$router.push("/produkty");
    },
    goToPaymentOptions: function(){
      this.$store.state.additionalInfo = this.additionalInfo;
      this.$router.push(`/opcje-platnosci`);
    },
    placeOrder: function () {
      this.orderLoading = true;
      let SI = this.$store.state.shippingInfo;
      let PM = this.$store.state.paymentMethod;
      delete SI["boxText"];
      this.$axios
        .post("/api/order/place", {
          shippingInfo: SI,
          paymentMethod:PM,
          additionalInfo: this.additionalInfo,
        })
        .then(async (response) => {
          if (response.data.success) {
            await this.$store.dispatch("clearCart");
            this.$router.push(`/platnosc/${response.data.orderNumber}`);
          } else {
            this.$toast.open({
              message: `<span class="font-weight-bold">${response.data.errorText}!</span>`,
              type: "error",
              duration: 3000,
              position: "bottom",
            });

            if (response.data.returnToCart) {
              await this.$store.dispatch("fetchCart");
              this.$router.push("koszyk");
            }
            this.orderLoading = false;
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: `<span class="font-weight-bold">Błąd podczas składania zamówienia!</span>`,
            type: "error",
            duration: 3000,
            position: "bottom",
          });
          this.orderLoading = false;
          console.log(error);
        });
    },
  },
  components: {},
};
</script>

<style>
.bg-transparent {
  background-color: transparent !important;
}
</style>
